import { Group } from "@mantine/core"
import { AgencyOperationsAdminVenueTabs } from "src/components/agency/operations/administrator/venues/AgencyOperationsAdminVenueTabs"
import { EditAgencyOperationsAdminVenueAction } from "src/components/agency/operations/administrator/venues/AgencyOperationsAdminVenueActions"
import { PageHeader } from "src/components/ui/PageHeader"
import { PageLayout } from "src/components/ui/PageLayout"
import { useAppState } from "src/state"
import { AgencyOperationsAdminVenueView } from "src/components/agency/operations/administrator/venues/AgencyOperationsAdminVenueView"

export function AgencyOperationsAdminVenue() {

    const { currentItem } = useAppState(state=>state.tenants)

    return (
        <PageLayout
            header={
                <PageHeader
                    title={`${currentItem?.name}`}
                    renderAction={
                        <Group gap="sm">
                            <EditAgencyOperationsAdminVenueAction />
                        </Group>
                    }
                />
            }
        >
            <AgencyOperationsAdminVenueTabs/>
            <AgencyOperationsAdminVenueView/>
            
        </PageLayout>
    )

}